import React from 'react'
import { useDispatch } from 'react-redux'
import { Sparkles, Check, ArrowRight, Info } from 'lucide-react'
import { openSuscriptionModal } from '../../../../../store/actions/profileActions.js'
import styles from './MessageLimitCard.module.scss'

interface MessageLimitCardProps {
  userData?: any
  isUserPremium: boolean
  remainingMessages: number
  limit: number
}

const PLANS = [
  {
    id: "1",
    name: "Mensual",
    price: 1500,
    period: "mes",
    discount: null,
  },
  {
    id: "2",
    name: "Semestral",
    price: 6000,
    period: "6 meses",
    discount: "20% OFF",
  },
  {
    id: "3",
    name: "Anual",
    price: 10800,
    period: "año",
    discount: "40% OFF",
    isRecommended: true
  }
]

const MessageLimitCard: React.FC<MessageLimitCardProps> = ({
  userData,
  isUserPremium,
  remainingMessages,
  limit
}) => {
  const dispatch = useDispatch()

  const handleOpenSubscriptionModal = () => {
    dispatch(openSuscriptionModal())
  }

  const currentPlanLabel = userData?.free_trial?.status === 'terminate' && !isUserPremium
    ? 'Plan Básico'
    : isUserPremium
    ? 'Plan Premium'
    : 'Plan Básico'

  return (
    <div className={styles.messageLimitCard}>
      <div className={styles.messageLimitCardHeader}>
        <div className={styles.messageLimitCardIcon}>
          <Info size={24} />
        </div>
        <div className={styles.messageLimitCardTitleSection}>
          <h3 className={styles.messageLimitCardTitle}>Alcanzaste el límite de mensajes</h3>
          <p className={styles.messageLimitCardSubtitle}>
            Plan actual: <strong>{currentPlanLabel}</strong> • Usaste {limit} de {limit} mensajes disponibles
          </p>
        </div>
      </div>

      <div className={styles.messageLimitCardContent}>
        <p className={styles.messageLimitCardDescription}>
          Con un plan premium podrás enviar mensajes ilimitados al asistente y acceder a todas las funcionalidades de Edify.
        </p>

        <div className={styles.messageLimitCardBenefits}>
          <div className={styles.messageLimitCardBenefit}>
            <Check size={18} className={styles.messageLimitCardCheck} />
            <span>Mensajes ilimitados al asistente</span>
          </div>
          <div className={styles.messageLimitCardBenefit}>
            <Check size={18} className={styles.messageLimitCardCheck} />
            <span>Publicar obras y recibir presupuestos sin límites</span>
          </div>
          <div className={styles.messageLimitCardBenefit}>
            <Check size={18} className={styles.messageLimitCardCheck} />
            <span>Acceso completo a obras públicas</span>
          </div>
          <div className={styles.messageLimitCardBenefit}>
            <Check size={18} className={styles.messageLimitCardCheck} />
            <span>Cotizar en obras y materiales sin restricciones</span>
          </div>
        </div>

        <div className={styles.messageLimitCardPlans}>
          {PLANS.map((plan) => (
            <div key={plan.id} className={`${styles.messageLimitCardPlan} ${plan.isRecommended ? styles.messageLimitCardPlanRecommended : ''}`}>
              {plan.isRecommended && (
                <div className={styles.messageLimitCardPlanBadge}>
                  <Sparkles size={12} />
                  Recomendado
                </div>
              )}
              <div className={styles.messageLimitCardPlanHeader}>
                <span className={styles.messageLimitCardPlanName}>{plan.name}</span>
                <div className={styles.messageLimitCardPlanPrice}>
                  <span className={styles.messageLimitCardPlanCurrency}>$</span>
                  <span className={styles.messageLimitCardPlanAmount}>{plan.price.toLocaleString('es-AR')}</span>
                  <span className={styles.messageLimitCardPlanPeriod}>/ {plan.period}</span>
                </div>
                {plan.discount ? (
                  <span className={styles.messageLimitCardPlanDiscount}>{plan.discount}</span>
                ) : (
                  <span className={styles.messageLimitCardPlanNoDiscount}>Cancelable en cualquier momento</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          className={styles.messageLimitCardCta}
          onClick={handleOpenSubscriptionModal}
        >
          Ver planes premium y suscribirse <ArrowRight size={18} />
        </button>
      </div>
    </div>
  )
}

export default MessageLimitCard
